type props = {}

const Profile: React.FC<props> = () => {
  return (
    <>
      profile
    </>
  )
}
export default Profile